import { Group, SaveButton } from '@/components/_common';
import {
  useMatrixCustomerSettingsCreate,
  useMatrixCustomerSettingsDetails,
  useMatrixCustomerSettingsUpdate,
} from '@/core/domain/enterprise/MatrixCustomerSettings/MatrixCustomerSettings.hooks';
import { MatrixCustomerSettingsFormValues } from '@/core/domain/enterprise/MatrixCustomerSettings/MatrixCustomerSettings.types';
import { useWindowSize } from '@/hooks';
import { initialTabErrors } from '@/pages/SettingsPages/CustomerSettingsPage';
import { Divider, Form, Typography } from 'antd';
import { useEffect } from 'react';
import CategoryConfigurationFields from './CategoryFields';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

interface Props {
  handleTabError: (key: keyof typeof initialTabErrors) => void;
  menuActive: boolean;
}

export default function CustomerConfigurationSettings({ menuActive }: Props) {
  const { width } = useWindowSize();

  const [form] = Form.useForm<MatrixCustomerSettingsFormValues>();

  const { data, dataUpdatedAt } = useMatrixCustomerSettingsDetails(menuActive);
  const create = useMatrixCustomerSettingsCreate();
  const update = useMatrixCustomerSettingsUpdate();

  useEffect(() => {
    if (data) {
      form.setFieldsValue(data);
    }
  }, [dataUpdatedAt]);

  async function handleSubmit() {
    const values = await form.validateFields();

    if (!data) {
      await create.mutateAsync(values);
    } else {
      await update.mutateAsync({ id: data.id, ...values });
    }
  }

  return (
    <>
      <Group position="between">
        <Typography.Title level={4} style={{ margin: 0 }}>
          Configuração
        </Typography.Title>

        {!(width < 992) && (
          <SaveButton
            type="primary"
            onClick={handleSubmit}
            disabled={
              !hasPermissions([
                Authorities.CONFIGURATION_MATRIX_SETTINGS_ADD_CUSTOMER,
                Authorities.CONFIGURATION_MATRIX_SETTINGS_EDIT_CUSTOMER,
              ])
            }
          >
            Salvar
          </SaveButton>
        )}
      </Group>

      <Divider />

      <Form form={form}>
        <CategoryConfigurationFields />
      </Form>
    </>
  );
}
